export const EcoCssInJsCBackgroundDark = "hsl(var(--hue-sat), 10%)";
export const EcoCssInJsCNavBackgroundDark = "hsl(var(--hue-sat), 7%)";
export const EcoCssInJsCCardBackgroundDark = "hsl(var(--hue-sat), 12%)";
export const EcoCssInJsCTableBackgroundDark = "hsl(var(--hue-sat), 12%)";
export const EcoCssInJsCCtaBackgroundDark = "hsl(var(--hue-sat), 13%)";
export const EcoCssInJsCBackgroundHslDark = "var(--hue-sat), 10%";
export const EcoCssInJsCNavBackgroundHslDark = "var(--hue-sat), 7%";
export const EcoCssInJsCCardBackgroundHslDark = "var(--hue-sat), 12%";
export const EcoCssInJsCContentBackgroundHslDark = "var(--hue-sat), 12%";
export const EcoCssInJsCTableBackgroundHslDark = "var(--hue-sat), 12%";
export const EcoCssInJsCCtaBackgroundHslDark = "var(--hue-sat), 13%";
export const EcoCssInJsCBorderBaseDark = "hsl(var(--hue-sat), 20%)";
export const EcoCssInJsCBorderWeakDark = "hsl(var(--hue-sat), 8%)";
export const EcoCssInJsCBorderStrongDark = "hsl(var(--hue-sat), 28%)";
export const EcoCssInJsCCodeTextDark = "hsl(var(--hue-sat), 96%)";
export const EcoCssInJsCCodeBorderDark = "hsl(var(--hue-sat), 25%)";
export const EcoCssInJsCCodeBackgroundDark = "hsl(var(--hue-sat), 20%)";
export const EcoCssInJsCCtaDefaultHslDark = "var(--igs-sky-blue-hsl)";
export const EcoCssInJsCCtaDefaultDark = "hsl(var(--igs-sky-blue-hsl))";
export const EcoCssInJsCCtaDefaultTransparentDark = "hsla(var(--igs-sky-blue-hsl), 0)";
export const EcoCssInJsCCtaDefaultMinorDark = "hsla(var(--igs-sky-blue-hsl), 0.15)";
export const EcoCssInJsCCtaDefaultWeakDark = "hsla(var(--igs-sky-blue-hsl), 0.3)";
export const EcoCssInJsCCtaDefaultMediumDark = "hsla(var(--igs-sky-blue-hsl), 0.5)";
export const EcoCssInJsCCtaDefaultHeavyDark = "hsla(var(--igs-sky-blue-hsl), 0.7)";
export const EcoCssInJsCCtaDefaultMajorDark = "hsla(var(--igs-sky-blue-hsl), 0.85)";
export const EcoCssInJsCCtaDefaultOpaqueDark = "hsla(var(--igs-sky-blue-hsl), 1)";
export const EcoCssInJsCCtaSuccessHslDark = "var(--igs-bright-green-hsl)";
export const EcoCssInJsCCtaSuccessDark = "hsl(var(--igs-bright-green-hsl))";
export const EcoCssInJsCCtaSuccessTransparentDark = "hsla(var(--igs-bright-green-hsl), 0)";
export const EcoCssInJsCCtaSuccessMinorDark = "hsla(var(--igs-bright-green-hsl), 0.15)";
export const EcoCssInJsCCtaSuccessWeakDark = "hsla(var(--igs-bright-green-hsl), 0.3)";
export const EcoCssInJsCCtaSuccessMediumDark = "hsla(var(--igs-bright-green-hsl), 0.5)";
export const EcoCssInJsCCtaSuccessHeavyDark = "hsla(var(--igs-bright-green-hsl), 0.7)";
export const EcoCssInJsCCtaSuccessMajorDark = "hsla(var(--igs-bright-green-hsl), 0.85)";
export const EcoCssInJsCCtaSuccessOpaqueDark = "hsla(var(--igs-bright-green-hsl), 1)";
export const EcoCssInJsCInputDisabledDark = "hsl(var(--hue-sat), 7%)";
export const EcoCssInJsCShadowDark = "hsla(var(--hue-sat), 4%, var(--alpha-weak))";
export const EcoCssInJsCShadowNavDark = "hsla(var(--hue-sat), 50%, var(--alpha-minor))";
export const EcoCssInJsCTableRowHighlightedDark = "hsl(var(--hue-sat), 5%)";
export const EcoCssInJsCTableRowEvenDark = "hsl(var(--hue-sat), 11%)";
export const EcoCssInJsCTextDark = "hsl(var(--hue-sat), 99%)";
export const EcoCssInJsCTextSecondaryDark = "hsl(var(--hue-sat), 90%)";
export const EcoCssInJsCTextOnOppositeBackgroundDark = "hsl(var(--hue-sat), 2%)";
export const EcoCssInJsHueSatDark = "var(--igs-deep-blue-h), 27%";